module.exports = __webpack_public_path__ + "static/media/by.c05c8c07.svg";